export default {
  isLogged: false,
};
